import React from "react";
export const SelectedTeamContext = React.createContext<{
  teamId: number;
  updateTeamId: (teamId: number) => void;
}>({
  teamId: 0,
  updateTeamId: () => {}
});
